import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Trophy, Users, Hash, MessageSquare, PlayCircle, Layers, Award, AlertTriangle, ArrowUpRight } from "lucide-react";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const [boards, setBoards] = useState(0);
  const [matches, setMatches] = useState(0);
  const [achievements, setAchievements] = useState(0);
  const [openTickets, setOpenTickets] = useState(0);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/boards").then((r) => setBoards(r.data.length));
    api.get("/matches").then((r) => setMatches(r.data.length));
    api.get("/achievements").then((r) => setAchievements(r.data.length));
    api.get("/tickets").then((r) => {
      setOpenTickets(r.data.filter((t) => t.status === "open" || t.status === "in_progress").length);
    });
  }, []);

  const cards = [
    { icon: Users, label: "Mitglieder", value: stats?.users || 0, link: "/admin/users", color: "text-primary" },
    { icon: Trophy, label: "Turniere", value: stats?.tournaments || 0, link: "/admin/tournaments", color: "text-primary" },
    { icon: PlayCircle, label: "Live Matches", value: matches, link: "/admin/live", color: "text-magenta" },
    { icon: Layers, label: "Boards", value: boards, link: "/admin/boards", color: "text-accent" },
    { icon: Hash, label: "Kanäle", value: stats?.channels || 0, link: "/admin/channels", color: "text-primary" },
    { icon: MessageSquare, label: "Nachrichten", value: stats?.messages || 0, link: "/admin/channels", color: "text-white/70" },
    { icon: Award, label: "Erfolge", value: achievements, link: "/admin/achievements", color: "text-magenta" },
    { icon: AlertTriangle, label: "Offene Tickets", value: openTickets, link: "/admin/tickets", color: openTickets > 0 ? "text-red-400" : "text-white/70" },
  ];

  return (
    <div className="space-y-8 fade-in" data-testid="admin-overview-page">
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gradient">Admin Dashboard</div>
        <h1 className="font-display text-4xl tracking-tight mt-2">Control Room</h1>
        <p className="text-white/60 text-sm mt-2">Steuere alle Aspekte des Nordgaming Portals.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5 border border-white/5">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.link}
            data-testid={`admin-stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="bg-bg p-5 hover:bg-surface transition-colors group"
          >
            <div className="flex items-center gap-2 text-white/40">
              <c.icon className={`w-3.5 h-3.5 ${c.color}`} />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em]">{c.label}</span>
              <ArrowUpRight className="w-3 h-3 ml-auto text-white/20 group-hover:text-primary transition-colors" />
            </div>
            <div className="font-display text-4xl tabular-nums mt-3 text-gradient">{c.value}</div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link to="/admin/live" className="card-solid p-5 hover:border-primary/40 transition-colors" data-testid="quick-create-match">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gradient">Quick Action</div>
          <div className="font-display text-xl mt-2">Live Match anlegen</div>
          <div className="text-sm text-white/60 mt-1">Score, Events und Stats live verwalten.</div>
        </Link>
        <Link to="/admin/boards" className="card-solid p-5 hover:border-primary/40 transition-colors" data-testid="quick-create-board">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gradient">Quick Action</div>
          <div className="font-display text-xl mt-2">Neues Kanban Board</div>
          <div className="text-sm text-white/60 mt-1">Frei konfigurierbare Rangliste mit eigenem Wallpaper.</div>
        </Link>
      </div>
    </div>
  );
}
